import { AppBar, Button, Container, Stack } from '@mui/material'
import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga4'
import { useLocation, useNavigate } from 'react-router'
import { SippLogo } from '../icons'

const baseStyle = {
  position: 'relative',
  borderBottom: 'none',
}

export const TestStripHeader = () => {
  const { pathname } = useLocation()
  const backgroundColor = pathname === '/landing' || pathname.startsWith('/test-strip') ? 'white' : '#F3F6F8'
  const navigate = useNavigate()
  const location = useLocation()
  return (
    <AppBar sx={{ ...baseStyle, backgroundColor }} elevation={0}>
      {location.pathname !== '/landing' && (
      <Container maxWidth="lg">
        <Stack
          width="100%"
          direction="row"
          height={68}
          alignItems="center"
          justifyContent="space-between"
        >
          <SippLogo sx={{ fontSize: '3rem', cursor: 'pointer' }} onClick={() => navigate('/')} />
          <Button
            variant="contained"
            disableElevation

            onClick={() => {

              ReactPixel.trackCustom('click', { id: 'get_sipp', name: 'Open get Sipp' })
              ReactGA.event({
                action: 'click',
                category: 'User event tracking',
                label: 'Open Get Sipp',
              })
              window.open('https://sippsafely.com')
            }}
          >
            Get Sipp
          </Button>
        </Stack>
      </Container>
      )}
    </AppBar>
  )
}
